import { Component } from '@angular/core';
import { MegamenuComponent } from '../../megamenu/megamenu.component';
import { FooterComponent } from '../../footer/footer.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { CompanyConfigService, CompanyConfig } from '../../../services/company-config.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-ant-control',
  templateUrl: './ant-control.component.html',
  styleUrl: './ant-control.component.css',
  imports: [MegamenuComponent, FooterComponent, MatButtonModule, MatIconModule, MatCardModule, CommonModule]
})
export class AntControlComponent {
  config: CompanyConfig;

  antTypes = [
    { name: 'Carpenter Ants', description: 'Large black ants that damage wood structures', severity: 'High' },
    { name: 'Pavement Ants', description: 'Small brown ants commonly found in driveways and sidewalks', severity: 'Medium' },
    { name: 'Pharaoh Ants', description: 'Tiny yellow ants that spread bacteria and are hard to eliminate', severity: 'High' },
    { name: 'Sugar Ants', description: 'Small ants attracted to sweet foods and moisture', severity: 'Low' },
    { name: 'Fire Ants', description: 'Aggressive red ants with painful stings', severity: 'High' }
  ];

  treatmentMethods = [
    { method: 'Baiting Systems', description: 'Strategic placement of ant baits to eliminate entire colonies' },
    { method: 'Perimeter Treatment', description: 'Exterior barrier treatment to prevent ant entry' },
    { method: 'Indoor Spot Treatment', description: 'Targeted treatment of ant trails and nesting areas' },
    { method: 'Exclusion Services', description: 'Sealing entry points to prevent future infestations' }
  ];

  constructor(
    private companyConfig: CompanyConfigService,
    private router: Router
  ) {
    this.config = this.companyConfig.getConfig();
  }

  callPhone() {
    this.companyConfig.callPhone();
  }

  navigateToContact() {
    this.router.navigate(['/contact']);
  }

  getSeverityColor(severity: string): string {
    switch (severity) {
      case 'High': return '#dc3545';
      case 'Medium': return '#ffc107';
      case 'Low': return '#28a745';
      default: return '#6c757d';
    }
  }
}